import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import {
	OperationResult,
	UpgradePreviewRequest,
	UpgradePreviewResponse,
} from '../../../admin/components/tools/UpgradeWizard/types';

export function usePreviewUpgradeMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (request: UpgradePreviewRequest) => {
			const response = await userSession.webServiceHelper.callAsync<OperationResult<UpgradePreviewResponse>>(
				'admin/BillingUtilities/PreviewSubscriptionUpgrade',
				'POST',
				request
			);

			// Handle both wrapped response { success, value } and unwrapped response
			if ('value' in response && 'success' in response) {
				if (!response.success || !response.value) {
					throw new Error(response.error || 'Failed to preview upgrade');
				}
				return response.value;
			}

			return response as unknown as UpgradePreviewResponse;
		},
	});
}
